'use client';

import { c as _c } from "react/compiler-runtime";
import { type RouterOutputs } from '@shared/all/domains/trpc';
import { X } from 'lucide-react';
import { allRequirementOptions } from '../../utils/requirementOptions';
import Avatar from '../common/Avatar';
const getRequirementLabel = (requirement: string): string => {
  const reqInfo = allRequirementOptions.find(opt => opt.value === requirement);
  return reqInfo?.label || requirement;
};
interface FactiiiCardProps {
  factiii: RouterOutputs['factiiis']['factiiiItems']['factiiiList'][number];
  onClick: () => void;
  onClose?: () => void;
  showCloseButton?: boolean;
  context?: string;
}
const FactiiiCard = t0 => {
  const $ = _c(30);
  const {
    factiii,
    onClick,
    onClose,
    showCloseButton,
    context
  } = t0;
  let t1;
  if ($[0] !== factiii.description) {
    t1 = factiii.description && factiii.description.length > 100 ? `${factiii.description.substring(0, 100)}...` : factiii.description;
    $[0] = factiii.description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const truncatedDescription = t1;
  let t2;
  if ($[2] !== onClose || $[3] !== showCloseButton) {
    t2 = showCloseButton && onClose && <button onClick={e => {
      e.stopPropagation();
      onClose();
    }} className="absolute right-3 top-3 z-10 rounded-full bg-background-light p-1.5 text-textSecondary/70 shadow-sm transition-all duration-200 hover:bg-background-light hover:text-textPrimary" aria-label="Close"><X size={14} /></button>;
    $[2] = onClose;
    $[3] = showCloseButton;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== factiii.avatarKey || $[6] !== factiii.id) {
    t3 = <div className="relative"><Avatar factiiiAvatarKey={factiii.avatarKey} factiiiId={factiii.id} size={48} className="rounded-xl ring-1 ring-ds-border-standard transition-all duration-200 group-hover:ring-ds-border-hover" /></div>;
    $[5] = factiii.avatarKey;
    $[6] = factiii.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== factiii.name) {
    t4 = <h4 className="truncate text-lg font-emphasis text-textPrimary">{factiii.name}</h4>;
    $[8] = factiii.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== context) {
    t5 = context && <span className="rounded-full bg-background-secondary px-2 py-1 text-xs font-emphasis text-textSecondary ring-1 ring-ds-border-standard">{context}</span>;
    $[10] = context;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex items-center gap-2">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== truncatedDescription) {
    t7 = truncatedDescription && <p className="mt-1 line-clamp-2 text-sm text-textSecondary/80">{truncatedDescription}</p>;
    $[15] = truncatedDescription;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== factiii.requirements) {
    t8 = factiii.requirements.length > 0 && <div className="mt-3 flex flex-wrap gap-1.5">{factiii.requirements.slice(0, 3).map(_temp)}{factiii.requirements.length > 3 && <span className="inline-flex items-center rounded-full bg-background-secondary px-2.5 py-1 text-xs font-emphasis text-textSecondary ring-1 ring-ds-border-standard">+{factiii.requirements.length - 3} more</span>}</div>;
    $[17] = factiii.requirements;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="ml-4 min-w-0 flex-1 text-start">{t6}{t7}{t8}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onClick || $[24] !== t3 || $[25] !== t9) {
    t10 = <div className="relative flex cursor-pointer items-center" onClick={onClick}>{t3}{t9}</div>;
    $[23] = onClick;
    $[24] = t3;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t2) {
    t11 = <div className="group relative overflow-hidden rounded-lg border border-ds-border-subtle bg-background-light p-4 transition-all duration-200 hover:border-ds-border-hover hover:bg-background-light">{t2}{t10}</div>;
    $[27] = t10;
    $[28] = t2;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
export default FactiiiCard;
function _temp(req) {
  return <span key={req} className="inline-flex items-center rounded-full bg-background-secondary px-2.5 py-1 text-xs font-emphasis text-textSecondary ring-1 ring-ds-border-standard">{getRequirementLabel(req)}</span>;
}